import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { FilterRowWithCheckbox } from "~/components/Filters/FilterRowWithCheckbox";
const filtersLabels = {
    "has-open-comments": "Has open comments",
    "has-versions": "Has versions",
    "is-favorited": "Favorite assets or files",
    "is-on-boards": "Is on boards",
    "is-untagged": "Is untagged"
};
export const defaultOtherFilters = [
    "is-favorited",
    "has-versions",
    "has-open-comments",
    "is-on-boards",
    "is-untagged"
];
export const OtherFilters = /*#__PURE__*/ memo((param)=>{
    let { otherFilters = defaultOtherFilters, selectedFilters, onTypeSelectedChange } = param;
    return /*#__PURE__*/ _jsx("div", {
        children: otherFilters.map((type)=>/*#__PURE__*/ _jsx(FilterRowWithCheckbox, {
                label: filtersLabels[type],
                isSelected: selectedFilters.includes(type),
                onChange: (isSelected)=>onTypeSelectedChange(type, isSelected)
            }, type))
    });
});
OtherFilters.displayName = "OtherFilters";
